import ElakayImage from '../../components/images/ElakayImage';
import React from "react";
import { MdDeleteForever, MdEdit, MdCancel, MdDesktopWindows, MdPhoneIphone } from "react-icons/md";
import "./PubGallery.css";
import { elakayAutoText } from "./dataElakay";
import { getElakayImageLoadUrl } from "../../config";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["pubgallery"]?.[key] || fallback;

/**
 * ===== PUB GALLERY - MODERN RESPONSIVE DESIGN =====
 * Beautiful gallery for pub images with device previews
 */

const PubGallery = ({
  category,
  getpub,
  getpubR,
  getpubC,
  elakayCategoryID,
  imagePubID,
  infoSource,
  toImageUrl,
  imgLakay,
  imgProductLakay,
  deleteImage,
  setImagePubID,
  ButtonPuB1500X400,
  ButtonCancel,
  setEmgEdit
}) => {
  __setElakayInfoSource(infoSource);

  // Render 1500x500 (Rectangle - Desktop/Mobile previews)
  const renderPub1500x500 = () => {
    if (!getpub || getpub.length === 0) return null;

    return (
      <div className="pub-section">
        <div className="pub-section-header">
          <h3 className="pub-section-title">
            {category.name[0]} {infoSource.laguangeElakay('title', infoSource.languageAPI).pub1500x500 || "Banner 1500x500"}
          </h3>
          <span className="pub-section-badge">{getpub.length}{__elakayText("t014", "images")}</span>
        </div>

        <div className="pub-gallery-grid">
          {getpub.map((p, i) => (
            <div key={i} className="pub-card">
              {/* Desktop Preview */}
              <div className="pub-image-wrapper">
                <ElakayImage preset="banner"
                  className="pub-image"
                  src={getElakayImageLoadUrl(toImageUrl(p.urlImg), { width: 600 })}
                  loading="lazy"
                  decoding="async"
                  onError={(e) => {
                    e.target.src = imgLakay;
                    e.onerror = null;
                  }}
                  alt={p.user}
                />

                {/* Overlay Controls */}
                <div className="pub-overlay">
                  <button
                    className="pub-overlay-btn pub-btn-delete"
                    onClick={() => deleteImage(elakayCategoryID, p._id, 1)}
                    title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pubgallery.t001}
                  >
                    <MdDeleteForever />
                  </button>
                  <button
                    className="pub-overlay-btn pub-btn-edit"
                    onClick={() => {
                      if (imagePubID !== p._id) {
                        setImagePubID(p._id);
                        ButtonPuB1500X400();
                        setEmgEdit(p.urlImg);
                      } else {
                        setImagePubID(null);
                        ButtonCancel();
                      }
                    }}
                    title={imagePubID === p._id ? elakayAutoText("h_77dfd2135f4db7", "Cancel") : elakayAutoText("h_5301648dcf6b53", "Edit")}
                  >
                    {imagePubID !== p._id ? <MdEdit /> : <MdCancel />}
                  </button>
                </div>

                {/* Device Label */}
                <div className="pub-device-label pub-device-desktop">
                  <MdDesktopWindows />
                  <span>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pubgallery.t002}</span>
                  <span className="pub-dimension-badge">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pubgallery.t003}</span>
                </div>
              </div>

              {/* Mobile Preview */}
              <div className="pub-image-wrapper pub-mobile-preview">
                <ElakayImage preset="banner"
                  className="pub-image"
                  src={getElakayImageLoadUrl(toImageUrl(p.urlImg), { width: 300 })}
                  loading="lazy"
                  decoding="async"
                  onError={(e) => {
                    e.target.src = imgLakay;
                    e.onerror = null;
                  }}
                  alt={p.user}
                />

                {/* Overlay Controls */}
                <div className="pub-overlay">
                  <button
                    className="pub-overlay-btn pub-btn-delete"
                    onClick={() => deleteImage(elakayCategoryID, p._id, 1)}
                    title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pubgallery.t004}
                  >
                    <MdDeleteForever />
                  </button>
                  <button
                    className="pub-overlay-btn pub-btn-edit"
                    onClick={() => {
                      if (imagePubID !== p._id) {
                        setImagePubID(p._id);
                        ButtonPuB1500X400();
                        setEmgEdit(p.urlImg);
                      } else {
                        setImagePubID(null);
                        ButtonCancel();
                      }
                    }}
                    title={imagePubID === p._id ? elakayAutoText("h_77dfd2135f4db7", "Cancel") : elakayAutoText("h_5301648dcf6b53", "Edit")}
                  >
                    {imagePubID !== p._id ? <MdEdit /> : <MdCancel />}
                  </button>
                </div>

                {/* Device Label */}
                <div className="pub-device-label pub-device-mobile">
                  <MdPhoneIphone />
                  <span>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pubgallery.t005}</span>
                  <span className="pub-dimension-badge">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pubgallery.t006}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Render 600x600 (Square) - Gère 700x700 et 400x712
  const renderPub600x600 = () => {
    if (!getpubR || !getpubR.urlImg) return null;

    return (
      <div className="pub-section">
        <div className="pub-section-header">
          <h3 className="pub-section-title">
            {category.name[0]} {infoSource.laguangeElakay('title', infoSource.languageAPI).pub600x600 || "Square 600x600"}
          </h3>
        </div>

        <div className="pub-gallery-grid pub-grid-square">
          {/* Desktop Preview - 700x700 (square) */}
          <div className="pub-card pub-card-square">
            <div className="pub-image-wrapper pub-wrapper-adaptive">
              <ElakayImage preset="banner"
                className="pub-image pub-image-adaptive-square"
                src={getElakayImageLoadUrl(toImageUrl(getpubR.urlImg), { width: 600 })}
                loading="lazy"
                decoding="async"
                onError={(e) => {
                  e.target.src = imgProductLakay;
                  e.onerror = null;
                }}
                alt={getpubR.user}
              />
              
              {/* Overlay Controls */}
              <div className="pub-overlay">
                <button
                  className="pub-overlay-btn pub-btn-delete"
                  onClick={() => deleteImage(elakayCategoryID, getpubR._id, 3)}
                  title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pubgallery.t007}
                >
                  <MdDeleteForever />
                </button>
              </div>

              {/* Device Label */}
              <div className="pub-device-label pub-device-desktop">
                <MdDesktopWindows />
                <span>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pubgallery.t008}</span>
                <span className="pub-dimension-badge">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pubgallery.t009}</span>
              </div>
            </div>
          </div>

          {/* Mobile Preview - 400x712 (portrait) */}
          <div className="pub-card pub-card-portrait">
            <div className="pub-image-wrapper pub-wrapper-adaptive">
              <ElakayImage preset="banner"
                className="pub-image pub-image-adaptive-portrait"
                src={getElakayImageLoadUrl(toImageUrl(getpubR.urlImg), { width: 300 })}
                loading="lazy"
                decoding="async"
                onError={(e) => {
                  e.target.src = imgProductLakay;
                  e.onerror = null;
                }}
                alt={getpubR.user}
              />
              
              {/* Overlay Controls */}
              <div className="pub-overlay">
                <button
                  className="pub-overlay-btn pub-btn-delete"
                  onClick={() => deleteImage(elakayCategoryID, getpubR._id, 3)}
                  title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pubgallery.t010}
                >
                  <MdDeleteForever />
                </button>
              </div>

              {/* Device Label */}
              <div className="pub-device-label pub-device-mobile">
                <MdPhoneIphone />
                <span>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pubgallery.t011}</span>
                <span className="pub-dimension-badge">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pubgallery.t012}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render 400x400 (Circle)
  const renderPub400x400 = () => {
    if (!getpubC || !getpubC.urlImg) return null;

    return (
      <div className="pub-section">
        <div className="pub-section-header">
          <h3 className="pub-section-title">
            {category.name[0]} {infoSource.laguangeElakay('title', infoSource.languageAPI).pub400x400 || "Circle 400x400"}
          </h3>
        </div>

        <div className="pub-gallery-grid pub-grid-circle">
          <div className="pub-card pub-card-circle">
            <div className="pub-image-wrapper pub-wrapper-circle">
              <ElakayImage preset="banner"
                className="pub-image pub-image-circle"
                src={getElakayImageLoadUrl(toImageUrl(getpubC.urlImg), { width: 300 })}
                loading="lazy"
                decoding="async"
                onError={(e) => {
                  e.target.src = imgProductLakay;
                  e.onerror = null;
                }}
                alt={getpubC.user}
              />
              
              {/* Overlay Controls */}
              <div className="pub-overlay">
                <button
                  className="pub-overlay-btn pub-btn-delete"
                  onClick={() => deleteImage(elakayCategoryID, getpubC._id, 2)}
                  title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pubgallery.t013}
                >
                  <MdDeleteForever />
                 
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="pub-gallery-container">
      {renderPub1500x500()}
      {renderPub600x600()}
      {renderPub400x400()}
    </div>
  );
};

export default PubGallery;